import React from 'react'
import { TypeVas } from '../../../interfaces/TypeVas/TypeVas'
import { utcToLocal } from '../../../utils/dateHelper'
import { YesNoBadge } from '../../../components/YesNoBadge'

export const getColumnsConfig = () => [
  { key: 'name' as keyof TypeVas, title: 'Código' },
  { key: 'description' as keyof TypeVas, title: 'Descripción' },
  {
    key: 'active' as keyof TypeVas,
    title: 'Activo',
    render: (value: string | number | boolean | undefined | Date) => (
      <YesNoBadge value={value as boolean} />
    )
  },
  {
    key: 'createdAt' as keyof TypeVas,
    title: 'Fecha Creación',
    render: (value: string | number | boolean | undefined | Date) => {
      return utcToLocal(value as Date, 'dd/MM/yyyy')
    }
  },
  {
    key: 'lastUpdate' as keyof TypeVas,
    title: 'Última Modificación',
    render: (value: string | number | boolean | undefined | Date) => {
      return utcToLocal(value as Date | undefined, 'dd/MM/yyyy')
    }
  },
  { key: 'userName' as keyof TypeVas, title: 'Usuario' }
]
